import { withoutUndefined } from './helpers'

export const addEndpoint = (url: URL, endpoint: string): URL => {
  const pathname =
    url.pathname === '/' ? endpoint : url.pathname + '/' + endpoint
  url.pathname = pathname
  return url
}

export const addQueryParams = (
  url: URL,
  params: { [key: string]: string | undefined }
): URL => {
  const search = new URLSearchParams(withoutUndefined(params))
  url.search = search.toString()
  return url
}
